import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ConsentRequestDetails.css';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import { Collapse, Form, Row, Col, Button, Alert } from 'reactstrap';
import { CONSENT_REQUESTS_FILTER } from "../../../reducers/consent/organizationConsents";
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import CertificateCard from "../certificateCard/CertificateCard.container";
import moment from 'moment';
import CancelConsentRequestModal from '../cancelConsentRequestModal/CancelConsentRequestModal.container';
import DismissConsentRequestModal from '../cancelConsentRequestModal/DismissConsentRequestModal.container';
import SelfStudyBookCard from "../selfStudyBookCard/SelfStudyBookCard.container";
import AccreditationRequestCard from "../accreditationRequestCard/AccreditationRequestCard.container";

const TABS = {
    REQUEST_DETAILS: "RequestDetails",
    CREDENTIALS: "Credentials",
    ACCREDITATIONS: "Accreditations",
    BOOKS: "Books",
    ACCREDITATION_REQUESTS: "AccreditationRequests"
};

class ConsentRequestDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenRequestDetails: false,
            isOpenCredentials: true,
            isOpenAccreditations: false,
            isOpenBooks: false,
            isOpenAccreditationRequests: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== this.props.id) {
            this.setState({
                isOpenRequestDetails: false,
                isOpenCredentials: true,
                isOpenAccreditations: false,
                isOpenBooks: false,
                isOpenAccreditationRequests: false
            });
            this.props.onResetSubmitFormData();
        }
    }

    render() {
        return (
            <div className="consent-request-details-container">
                {this.renderContent()}
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="consent-request-details-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (!_.isNil(this.props.data)) {
            return (
                <div>
                    {this.renderDismissRequestButton()}
                    <h3 className="text-center">{_.get(this.props.translation, 'consents.status_title.' + this.props.data.status)}</h3>
                    <div className="consent-request-details-expire-label">
                        {this.renderRequestsCardDate()}
                    </div>
                    <div
                        className={"consent-request-details-tab-header-container olive-green " + (this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED ? "switchable" : "")}>
                        <h4 onClick={this.toggle(TABS.REQUEST_DETAILS)}>
                            <u>{_.get(this.props.translation, "consents.request_details_label")}</u></h4>
                        {this.renderCollapseArrow(TABS.REQUEST_DETAILS)}
                    </div>
                    {this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED ?
                        <Collapse isOpen={this.state.isOpenRequestDetails}>
                            {this.renderRequestDetails()}
                        </Collapse>
                        : this.renderRequestDetails()}
                    {this.renderCredentials()}
                    <CancelConsentRequestModal id={this.props.id} />
                    <DismissConsentRequestModal id={this.props.id} />
                </div>
            );
        } else {
            return (
                <h6 className="text-center">{_.get(this.props.translation, "consents.no_selected_consent_request_label")}</h6>
            );
        }
    };

    renderRequestsCardDate = () => {
        switch (this.props.data.status) {
            case CONSENT_REQUESTS_FILTER.GRANTED:
                return _.get(this.props.translation, "consents.expires_label") + " " + moment(this.props.data.grantedTill).format("MMMM Do YYYY, HH:mm");

            case CONSENT_REQUESTS_FILTER.EXPIRED:
                return _.get(this.props.translation, "consents.expired_label") + " " + moment(this.props.data.grantedTill).format("MMMM Do YYYY, HH:mm");

            case CONSENT_REQUESTS_FILTER.REVOKED:
                return _.get(this.props.translation, "consents.revoked_label") + " " + moment(this.props.data.updatedAt).format("MMMM Do YYYY, HH:mm");

            default:
                return null;
        }
    };

    renderRequestDetails = () => {
        return (
            <Form>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, "consents.target_label") + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        <a href={"mailto:" + this.props.data.applicant.email}>{this.props.data.applicant.email}</a>
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, "consents.created_by_label") + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        <div>
                            {this.props.data.requester.identityAlias.firstName + " " + this.props.data.requester.identityAlias.lastName}
                            {this.props.data.showRequesterFNLN ? null : (" (" + _.get(this.props.translation, "consents.hidden_for_applicant_label") + ")")}
                        </div>
                        {
                            !_.isNil(this.props.data.contactEmail) ?
                                <div>
                                    <a href={"mailto:" + this.props.data.contactEmail}>{this.props.data.contactEmail}</a>
                                </div>
                                : null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, sharedLabelsPath.company_label) + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        {this.props.organizationData.name + ", " + _.get(this.props.translation, 'countries.' + this.props.organizationData.address.countryCode) + ", " + this.props.organizationData.address.city}
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, 'consents.internal_job_reference') + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        {this.props.data.jobDescription.internalReference}
                        {!this.props.data.jobDescription.exposeReference && !_.isNil(this.props.data.jobDescription.internalReference) ?
                            (" (" + _.get(this.props.translation, "consents.hidden_for_applicant_label") + ")")
                            :
                            null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, "consents.job_title_label") + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        {this.props.data.jobDescription.title}
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>
                        <h6>{_.get(this.props.translation, "consents.note_to_applicants_label") + ":"}</h6>
                    </Col>
                    <Col sm={10}>
                        <i>{this.props.data.requestComment}</i>
                    </Col>
                </Row>
                {this.renderCancelRequestButton()}
                {this.renderApplicantResponse()}
            </Form>
        )
    };

    renderCredentials = () => {
        if (this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED) {
            return (
                <div>
                    <div className="consent-request-details-tab-header-container switchable olive-green">
                        <h4 onClick={this.toggle(TABS.CREDENTIALS)}>
                            <u>{_.get(this.props.translation, "consents.credentials_label")}</u></h4>
                        {this.renderCollapseArrow(TABS.CREDENTIALS)}
                    </div>
                    <Collapse isOpen={this.state.isOpenCredentials}>
                        <h5 className="text-center applicant-name">
                            {this.renderApplicantName()}
                            {this.renderVIDData()}
                        </h5>
                        <Row>
                            <Col sm={2}>
                                <h6>{_.get(this.props.translation, sharedLabelsPath.email_label) + ":"}</h6>
                            </Col>
                            <Col sm={10}>
                                <a href={"mailto:" + this.props.data.applicant.email}>{this.props.data.applicant.email}</a>
                            </Col>
                        </Row>
                        {
                            this.props.data.applicant.identityAlias.phoneNumber ?
                                <Row>
                                    <Col sm={2}>
                                        <h6>{_.get(this.props.translation, sharedLabelsPath.phone_number_label) + ":"}</h6>
                                    </Col>
                                    <Col sm={10}>
                                        {this.props.data.applicant.identityAlias.phoneNumber}
                                    </Col>
                                </Row>
                                : null
                        }
                        {
                            !_.isEmpty(this.props.data.accreditations) ?
                                <div className="certificate-tab olive-green">
                                    <h5 onClick={this.toggle(TABS.ACCREDITATIONS)}>
                                        {_.get(this.props.translation, 'consents.accreditations_label')}
                                    </h5>
                                    {this.renderCollapseArrow(TABS.ACCREDITATIONS)}
                                </div>
                                : null
                        }
                        <Collapse isOpen={this.state.isOpenAccreditations}>
                            {this.renderCertificates()}
                        </Collapse>
                        {
                            !_.isEmpty(this.props.data.selfStudyBooks) ?
                                <div className="certificate-tab olive-green">
                                    <h5 onClick={this.toggle(TABS.BOOKS)}>
                                        {_.get(this.props.translation, 'consents.self_study_books_label')}
                                    </h5>
                                    {this.renderCollapseArrow(TABS.BOOKS)}
                                </div>
                                : null
                        }
                        <Collapse isOpen={this.state.isOpenBooks}>
                            {this.renderSelfStudyBooks()}
                        </Collapse>
                        {
                            !_.isEmpty(this.props.data.accreditationRequests) ?
                                <div className="certificate-tab olive-green">
                                    <h5 onClick={this.toggle(TABS.ACCREDITATION_REQUESTS)}>
                                        {_.get(this.props.translation, 'accreditation_requests.accreditations_pending_approval_label')}
                                    </h5>
                                    {this.renderCollapseArrow(TABS.ACCREDITATION_REQUESTS)}
                                </div>
                                : null
                        }
                        <Collapse isOpen={this.state.isOpenAccreditationRequests}>
                            {this.renderAccreditationRequests()}
                        </Collapse>
                    </Collapse>
                </div>
            )
        }
    };

    renderApplicantName = () => {
        let vid = this.props.data.verifiedIdentity;
        if (_.has(vid, 'firstName') && _.has(vid, 'lastName')) {
            return vid.firstName + " " + vid.lastName;
        }
        return this.props.data.applicant.identityAlias.firstName + " " + this.props.data.applicant.identityAlias.lastName;
    };

    renderVIDData = () => {
        let vid = this.props.data.verifiedIdentity;
        let vidData = '';
        if (_.has(vid, 'countryCode')) {
            vidData += _.get(this.props.translation, "countries." + vid.countryCode);
        }
        if (_.has(vid, 'nationalId')) {
            vidData += (_.isEmpty(vidData) ? '' : ', ') + (vid.nationalId.length === 4 ? "*" : "") + vid.nationalId;
        }
        return _.isEmpty(vidData) ? null : <span className="vid-data">({vidData})</span>;
    };

    renderCertificates = () => {
        //TODO: add certificates types - Accreditation & Booc (and also MOOC later)
        return _.map(this.props.data.accreditations, (elem, id) => {
            return <CertificateCard data={elem} key={id} />;
        })
    };

    renderSelfStudyBooks = () => {
        return _.map(this.props.data.selfStudyBooks, (elem, id) => {
            return <SelfStudyBookCard data={elem} key={id} />;
        })
    };

    renderAccreditationRequests = () => {
        return _.map(this.props.data.accreditationRequests, (elem, id) => {
            return <AccreditationRequestCard data={elem} key={id} />;
        })
    };

    renderCollapseArrow = (tab) => {
        if (this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED) {
            let iconName = "keyboard_arrow_" + (this.state['isOpen' + tab] ? "down" : "right");
            return (
                <IconContainer onClick={this.toggle(tab)} className="consent-request-details-tab-header-icon"
                    icon={iconName} />
            )
        }
    };

    renderCancelRequestButton = () => {
        if (this.props.data.status === CONSENT_REQUESTS_FILTER.PENDING && this.props.userId === this.props.data.requester.id) {
            return (
                <div className="consent-request-details-button-container">
                    <Button className="carrot-red-btn"
                        onClick={this.props.onCancelPendingRequest}>{_.get(this.props.translation, "consents.cancel_request_button_label")}</Button>
                </div>
            );
        }
    };

    renderDismissRequestButton = () => {
        if (this.props.data.status !== CONSENT_REQUESTS_FILTER.PENDING) {
            return (
                <div className="consent-request-details-button-container">
                    <IconContainer icon="clear"
                        className="consent-request-details-button-icon"
                        title={_.get(this.props.translation, "consents.dismiss_request_button_label")}
                        onClick={this.props.onDismissRequest}
                    />
                </div>
            );
        }
    };

    renderApplicantResponse = () => {
        if (!_.isNil(this.props.data.responseComment) && this.props.data.responseComment !== "") {
            let color = this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED || this.props.data.status === CONSENT_REQUESTS_FILTER.EXPIRED ? "success" : "warning";
            return (
                <div>
                    <h6>{_.get(this.props.translation, "consents.applicant_response_label") + ":"}</h6>
                    <Alert color={color}>{this.props.data.responseComment}</Alert>
                </div>
            )
        }
    };

    toggle = (tab) => () => {
        if (this.props.data.status === CONSENT_REQUESTS_FILTER.GRANTED) {
            this.setState({ ['isOpen' + tab]: !this.state['isOpen' + tab] });
        }
    };
}

ConsentRequestDetails.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    organizationData: PropTypes.object,
    userId: PropTypes.string,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onCancelPendingRequest: PropTypes.func,
    onDismissRequest: PropTypes.func,
    onResetSubmitFormData: PropTypes.func
};

export default ConsentRequestDetails;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestDetails/ConsentRequestDetails.js